// extracted by mini-css-extract-plugin
export default {"container":"styles_container__O07Ov","lostPasswordBTN":"styles_lostPasswordBTN__INDSZ"};